import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import invariant from 'invariant';
import { BaseField } from 'uniforms';
import { createElement } from 'react';
import BoolField from './BoolField';
import DateField from './DateField';
import ListField from './ListField';
import NestField from './NestField';
import NumField from './NumField';
import RadioField from './RadioField';
import SelectField from './SelectField';
import TextField from './TextField';

var AutoField =
/*#__PURE__*/
function (_BaseField) {
  _inherits(AutoField, _BaseField);

  function AutoField() {
    _classCallCheck(this, AutoField);

    return _possibleConstructorReturn(this, _getPrototypeOf(AutoField).apply(this, arguments));
  }

  _createClass(AutoField, [{
    key: "getChildContextName",
    value: function getChildContextName() {
      return this.context.uniforms.name;
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.getFieldProps(undefined, {
        ensureValue: false
      });

      if (props.component === undefined) {
        if (props.allowedValues) {
          if (props.checkboxes && props.fieldType !== Array) {
            props.component = RadioField;
          } else {
            props.component = SelectField;
          }
        } else {
          switch (props.fieldType) {
            case Date:
              props.component = DateField;
              break;

            case Array:
              props.component = ListField;
              break;

            case Number:
              props.component = NumField;
              break;

            case Object:
              props.component = NestField;
              break;

            case String:
              props.component = TextField;
              break;

            case Boolean:
              props.component = BoolField;
              break;
          }

          invariant(props.component, 'Unsupported field type: %s', props.fieldType.toString());
        }
      }

      return createElement(props.component, this.props);
    }
  }]);

  return AutoField;
}(BaseField);

export { AutoField as default };
AutoField.displayName = 'AutoField';